module.exports = __webpack_public_path__ + "static/media/016.8841ad12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/016.jpg
// module id = 560
// module chunks = 0